export class UnexpectedColumnError extends Error {
    expectedColumnsCount;
    rowPos;
    constructor(expectedColumnsCount, rowPos) {
        super(`Expected ${expectedColumnsCount} columns, but get more in a row #${rowPos}`);
        this.expectedColumnsCount = expectedColumnsCount;
        this.rowPos = rowPos;
    }
}
//# sourceMappingURL=UnexpectedColumnError.js.map